export const showSeconds = (timer: number) => {
  if (timer > 60 || timer <= 0) {
    return "00";
  }
  if (timer < 10) {
    return `0${timer}`;
  }
  return `${timer}`;
};
